import { combineReducers } from "redux";
import { clientesReducer } from "./redux/clientes";
import { devolucionesReducer } from "./redux/devoluciones";
import { estadosIncidenciaFullfilledReducer } from "./redux/estadosIncidencia";
import { estadosVentaFullfilledReducer } from "./redux/estadosVenta";
import { facturasReducer } from "./redux/facturas";
import { familiaPiezaFullfilledReducer } from "./redux/familiaPiezas";
import { incidenciasReducer } from "./redux/incidencias";
import { marcasFullfilledReducer } from "./redux/marcas";
import { modelosFullfilledReducer } from "./redux/modelos";
import { paisesFullfilledReducer } from "./redux/paises";
import { plataformasFullfilledReducer } from "./redux/plataformas";
import { poblacionesFullfilledReducer } from "./redux/poblaciones";
import { presupuestosReducer } from "./redux/presupuestos";
import { proveedoresReducer } from "./redux/proveedores";
import { rolesFullfilledReducer } from "./redux/roles";
import { searchReducer } from "./redux/features/search";
import { tipoClientesFullfilledReducer } from "./redux/tipoClientes";
import { tipoClientesB2bFullfilledReducer } from "./redux/tipoClientesB2b";
import { tipoDevolucionesFullfilledReducer } from "./redux/tipoDevoluciones";
import { tipoFacturasFullfilledReducer } from "./redux/tipoFacturas";
import { tipoGarantiasFullfilledReducer } from "./redux/tipoGarantias";
import { tipoIncidenciasFullfilledReducer } from "./redux/tipoIncidencias";
import { tipoPiezasFullfilledReducer } from "./redux/tipoPiezas";
import { usersReducer } from "./redux/users";
import { ventasReducer } from "./redux/ventas";
import { avisosReducer } from "./redux/avisos";
import { fichaIncidenciaReducer, currentIncidenciaStatusReducer } from "./redux/features/fichaIncidencia";
import { dashboardReducer, dashboardStatusReducer } from "./redux/features/dashboard";
import { currentClienteReducer, currentClienteStatusReducer } from "./redux/features/currentCliente";
import { currentUserReducer, currentUserStatusReducer } from "./redux/features/currentUser";
import { currentPiezaReducer } from "./redux/features/currentPieza";
import { currentProveedorReducer } from "./redux/features/currentProveedor";
import { fichaClienteReducer, fichaClienteStatusReducer } from "./redux/features/fichaCliente";
import { fichaProveedorReducer, fichaProveedorStatusReducer } from "./redux/features/fichaProveedor";
import { tarifasFullfilledReducer } from "./redux/tarifas";
import { stepsFullfilledReducer } from "./redux/incidenciaSteps";
import { avisosListReducer, avisosListStatusReducer } from "./redux/features/avisosList";
import { administracionFullfilledReducer, atencionClienteFullfilledReducer, comercialesFullfilledReducer, recambistasFullfilledReducer, } from "./redux/features/tipoUsers";
import { readOnlyDataReducer } from "./redux/readOnly";
import { notificacionesReducer } from "./redux/features/notificaciones";
import { serviciosEnvioFullfilledReducer } from "./redux/serviciosEnvio";
import { transportistasFullfilledReducer } from "./redux/transportistas";
import { preciosEnvioPiezasFullfilledReducer } from "./redux/preciosEnviosPiezas";
import { enviosReducer } from "./redux/envios";
import { solicitudesReducer } from "./redux/solicitudes";
import { desguacesOfflineReducer } from "./redux/desguaces_offline";
import { reconstruidosReducer } from "./redux/reconstruidos";
import { albaranesReducer } from "./redux/albaranes";
import { tipoFeedbackFullfilledReducer } from "./redux/tipoFeedback";
import { finanzasReducer } from "./redux/features/finanzas";
import { comercialDetailReducer } from "./redux/comercial_detail";
import { fichaPresupuestoReducer, fichaPresupuestoStatusReducer } from "./redux/features/fichaPresupuesto";
import { tarifasProveedorFullfilledReducer } from "./redux/tarifas_envio_proveedor";
import { avisosStockReducer } from "./redux/avisos_stock";
import { tipoVencimientoFullfilledReducer } from "./redux/tipoVencimientos";
import { subestadosIncidenciaFullfilledReducer } from "./redux/subestadosIncidencia";
import { recordatoriosClientesReducer } from "./redux/features/recordatoriosClientes";
import { loadingReducer } from "./redux/features/loading";
import { fichaSearchReducer } from "./redux/features/fichaSearch";
import { tipoBancosFullfilledReducer } from "./redux/tipoBancos";
import { notasCargoReducer } from "./redux/notasCargo";
import { autorizacionesReducer } from "./redux/autorizacionesCredito";
import { reloadReducer } from "./redux/features/reload";
import { variablesFullfilledReducer } from "./redux/variables";
import { carroceriasPesadasFullfilledReducer } from "./redux/carroceriasPesadas";
import { plantillasEmailFullfilledReducer } from "./redux/plantillasEmail";
import { ventasPendientesReducer } from './redux/ventasPendientes';
import { dashboardPantallaReducer } from './redux/dashboardPantalla';
import { solicitudAlternativasFullfilledReducer } from "./redux/solicitudAlternativas";
import repartosReducer from "./redux/features/repartos";

const reducer = combineReducers({
    // UTILITIES
    search: searchReducer,
    ficha_search: fichaSearchReducer,
    // DATA LIST
    albaranes: albaranesReducer,
    notas_cargo: notasCargoReducer,
    avisos: avisosReducer,
    clientes: clientesReducer,
    presupuestos: presupuestosReducer,
    envios: enviosReducer,
    devoluciones: devolucionesReducer,
    facturas: facturasReducer,
    incidencias: incidenciasReducer,
    notificaciones: notificacionesReducer,
    proveedores: proveedoresReducer,
    detalles: comercialDetailReducer,
    users: usersReducer,
    ventas: ventasReducer,
    ventas_pendientes: ventasPendientesReducer,
    solicitudes: solicitudesReducer,
    desguaces_offline: desguacesOfflineReducer,
    reconstruidos: reconstruidosReducer,
    repartos: repartosReducer,
    // READ ONLY DATA
    read_only: readOnlyDataReducer,
    //-------------------------------
    tipo_clientes: tipoClientesFullfilledReducer,
    tipo_clientes_b2b: tipoClientesB2bFullfilledReducer,
    tipo_bancos: tipoBancosFullfilledReducer,
    poblaciones: poblacionesFullfilledReducer,
    paises: paisesFullfilledReducer,
    roles: rolesFullfilledReducer,
    estados_venta: estadosVentaFullfilledReducer,
    estados_incidencia: estadosIncidenciaFullfilledReducer,
    subestados_incidencia: subestadosIncidenciaFullfilledReducer,
    tipo_facturas: tipoFacturasFullfilledReducer,
    tipo_piezas: tipoPiezasFullfilledReducer,
    familia_piezas: familiaPiezaFullfilledReducer,
    tipo_garantias: tipoGarantiasFullfilledReducer,
    tipo_devoluciones: tipoDevolucionesFullfilledReducer,
    tipo_incidencias: tipoIncidenciasFullfilledReducer,
    tipo_feedback: tipoFeedbackFullfilledReducer,
    marcas: marcasFullfilledReducer,
    modelos: modelosFullfilledReducer,
    plataformas: plataformasFullfilledReducer,
    tarifas: tarifasFullfilledReducer,
    steps: stepsFullfilledReducer,
    transportistas: transportistasFullfilledReducer,
    servicios_envio: serviciosEnvioFullfilledReducer,
    precios_envios_piezas: preciosEnvioPiezasFullfilledReducer,
    tarifas_envio_proveedor: tarifasProveedorFullfilledReducer,
    tipo_vencimientos: tipoVencimientoFullfilledReducer,
    recambistas: recambistasFullfilledReducer,
    comerciales: comercialesFullfilledReducer,
    atencion_cliente: atencionClienteFullfilledReducer,
    administracion: administracionFullfilledReducer,
    variables: variablesFullfilledReducer,
    carrocerias_pesadas: carroceriasPesadasFullfilledReducer,
    plantillas_email: plantillasEmailFullfilledReducer,
    solicitud_alternativas: solicitudAlternativasFullfilledReducer,
    //-------------------------------
    // CURRENT DATA
    loading: loadingReducer,
    reload: reloadReducer,
    dashboard: combineReducers({
        entity: dashboardReducer,
        status: dashboardStatusReducer
    }),
    presupuesto: combineReducers({
        entity: fichaPresupuestoReducer,
        status: fichaPresupuestoStatusReducer
    }),
    currentIncidencia: combineReducers({
        entity: fichaIncidenciaReducer,
        status: currentIncidenciaStatusReducer
    }),
    currentCliente: combineReducers({
        entity: currentClienteReducer,
        status: currentClienteStatusReducer
    }),
    currentUser: combineReducers({
        entity: currentUserReducer,
        status: currentUserStatusReducer
    }),
    currentPieza: currentPiezaReducer,
    currentProveedor: currentProveedorReducer,
    fichaCliente: combineReducers({
        entity: fichaClienteReducer,
        status: fichaClienteStatusReducer
    }),
    fichaProveedor: combineReducers({
        entity: fichaProveedorReducer,
        status: fichaProveedorStatusReducer
    }),
    avisosList: combineReducers({
        entity: avisosListReducer,
        status: avisosListStatusReducer
    }),
    finanzas: finanzasReducer,
    avisosStock: avisosStockReducer,
    recordatorios: recordatoriosClientesReducer,
    autorizaciones: autorizacionesReducer,
    dashboardPantalla: dashboardPantallaReducer,
})

const rootReducer = reducer;

export default rootReducer;